// Prevents two concurrent microphone captures (visit transcription vs. note
// dictation) from running at once, which would double-record the speaker.
export type MicOwner = 'visit' | 'dictation';

let owner: MicOwner | null = null;

export const micLock = {
  tryAcquire(who: MicOwner): boolean {
    if (owner && owner !== who) return false;
    owner = who;
    return true;
  },
  release(who: MicOwner): void {
    if (owner === who) owner = null;
  },
  isHeldByOther(who: MicOwner): boolean {
    return owner !== null && owner !== who;
  },
};
